import React, { useState } from "react";
import { Table, Tag, Button, Modal } from "antd";
import { statusList } from "../../../../utils";
import { ExportToExcel } from "../../../../utils";

export const ClientTable = ({ data }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  console.log("data", data)

  const groupedData = data?.reduce((acc, client) => {
    if (!acc[client.phoneNumber]) {
      acc[client.phoneNumber] = {
        customerName: client.customerName,
        phoneNumber: client.phoneNumber,
        channel: client.channel,
        products: [],
        totalSales: 0,
        dateStart: [],
      };
    }

    client.products?.forEach((product) => {
      const existingProduct = acc[client.phoneNumber].products.find(p =>
        p.category === product.category &&
        p.brand === product.brand &&
        p.model === product.model &&
        p.color === product.color &&
        p.size === product.size
      );
      if (!existingProduct) {
        acc[client.phoneNumber].products.push(product);
      }
    });

    acc[client.phoneNumber].totalSales += parseFloat(client.saleAmount);
    acc[client.phoneNumber].dateStart.push(client.dateStart.toDate());

    return acc;
  }, {});


  const counts = Object.fromEntries(
    Object.keys(statusList).map((status) => [
      status,
      {
        count: 0,
        phoneNumbers: new Set(),
        color: statusList[status].color,
      },
    ])
  );

  data?.forEach((client) => {
    const status = client.status;
    if (status && counts[status]) {
      if (client.phoneNumber) {
        const phoneSet = counts[status].phoneNumbers;
        if (!phoneSet.has(client.phoneNumber)) {
          counts[status].count++;
          phoneSet.add(client.phoneNumber);
        }
      }
    }
  });

  const dataSource = Object.keys(counts).map((status) => {
    return {
      status: status,
      count: counts[status].count,
      color: counts[status].color,
      actions: (
        <Button onClick={() => handleDetails(status)} className="btnCancel">
          Detalles
        </Button>
      ),
    };
  });

  const columns = [
    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color={statusList[status]?.color}>{status}</Tag>,
    },
    {
      title: "Cantidad/Clientes",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "Detalles",
      dataIndex: "actions",
      key: "actions",
    },
  ];

  const handleDetails = (status) => {
    setSelectedStatus(status);
    const clientsWithStatus = data
      .filter((client) => client.status === status)
      .map((client) => groupedData[client.phoneNumber]);
    setSelectedClient(clientsWithStatus);
    setModalVisible(true);
  };

  const modalColumns = [
    {
      title: "Nombre del cliente",
      dataIndex: "customerName",
      key: "customerName",
      width: 200,
    },
    {
      title: "Número de teléfono",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: 200,
    },
    {
      title: "Canal de compra",
      dataIndex: "channel",
      key: "channel",
      width: 200,
    },
    {
      title: "Productos",
      key: "products",
      render: (text, record) => {
        return record.products.map(product => (
          <div key={product.model}>
            Categoria: {product.category} -
            Marca: {product.brand} -
            Modelo: {product.model} -
            Color: {product.color} -
            Talla: {product.size}
          </div>
        ))
      },
      width: 500,
    },
    {
      title: "Suma total de venta",
      key: "totalSales",
      render: (text, record) => `/S ${record.totalSales.toFixed(2)}`,
      width: 200,
    },

    {
      title: "Fecha de inicio",
      dataIndex: "dateStart",
      key: "dateStart",
      render: (text, record) =>
        record.dateStart.sort().reverse()[0].toLocaleDateString(),
      width: 150,
    },
  ];

  const transformDataForExcel = (data) => {
    return data?.flatMap((item) => {
      return item.products?.map(product => {
        return {
          "Nombre del cliente": item.customerName,
          "Número de teléfono": item.phoneNumber,
          Canal: item.channel,
          Categoria: product.category,
          Marca: product.brand,
          Modelo: product.model,
          Color: product.color,
          Talla: product.size,
          "Suma total de venta": `S/ ${item.totalSales?.toFixed(2)}`,
          "Fecha de inicio": item.dateStart
            .sort()
            .reverse()[0]
            .toLocaleDateString(),
        };
      });
    });
  };




  const excelColumns = [
    {
      title: "Nombre del cliente",
      dataIndex: "Nombre del cliente",
      key: "Nombre del cliente",
      width: 200,
    },
    {
      title: "Número de teléfono",
      dataIndex: "Número de teléfono",
      key: "Número de teléfono",
      width: 200,
    },
    {
      title: "Canal de compra",
      dataIndex: "Canal",
      key: "Canal",
      width: 200,
    },
    {
      title: "Categorías",
      key: "Categoria",
      dataIndex: "Categoria",
      width: 200,
    },
    {
      title: "Marcas",
      key: "Marca",
      dataIndex: "Marca",
      width: 200,
    },
    {
      title: "Modelo",
      key: "Modelo",
      dataIndex: "Modelo",
      width: 200,
    },
    {
      title: "Color",
      key: "Color",
      dataIndex: "Color",
    },
    {
      title: "Talla",
      key: "Talla",
      dataIndex: "Talla",
      width: 100,
    },
    {
      title: "Suma total de venta",
      dataIndex: "Suma total de venta",
      key: "Suma total de venta",
      width: 400,
    },
    {
      title: "Fecha de inicio",
      dataIndex: "Fecha de inicio",
      key: "Fecha de inicio",
      width: 150,
    },
  ];

  return (
    <div className="w-full pt-4 pr-4 pl-4">
      <div className="overflow-x-auto h-96">
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
        />
      </div>
      <Modal
        title="Detalle"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        width={950}
        footer={
          <ExportToExcel
            data={transformDataForExcel(selectedClient)}
            fileName={`clientes${selectedStatus}`}
            columns={excelColumns}
          />
        }
      >
        {selectedClient && (
          <div className="overflow-x-auto h-96">
            <Table
              dataSource={selectedClient}
              columns={modalColumns}
              pagination={false}
            />
          </div>
        )}
      </Modal>
    </div>
  );
};
